import React, { useContext, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { DropsContext } from 'contexts/DropsContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import { useDialog } from 'components/Modals';
import RelatorioModal from 'components/Modals/RelatorioModal';
import Navbar from 'components/Navbar';
import Routes from 'routes';

const styles = {
  main: {
    height: '100vh',
  },
  container: {
    padding: '88px 24px 0 24px',
  },
};

const App = () => {
  const { openDialog } = useDialog();
  const { getDrops } = useContext(DropsContext);
  const { relatorio } = useContext(RelatoriosContext);
  const { getNotifications } = useContext(NotificaçõesContext);

  useEffect(() => {
    getNotifications();
    getDrops([
      'Afastamento',
      'AgenteCausador',
      'Ambiente',
      'Anp',
      'AtividadeEntidade',
      'AtividadeExprisco',
      'Cargo',
      'Cat',
      'CategoriaTrabalhador',
      'Ccusto',
      'Cfiscal',
      'Cfo',
      'Cidade',
      'ClasseCnae',
      'CondicaoPagamento',
      'Contribuinte',
      'Cxconta',
      'Desligamento',
      'DivisaoCnae',
      'Entidade',
      'EntidadeEndereco',
      'EntidadeProcessos',
      'EntidadeTipo',
      'EntidadeTributacao',
      'EtiquetaModelo',
      'FatorRisco',
      'Filial',
      'FormaDePagamento',
      'Gradesalario',
      'GrupoCnae',
      'GrupoEntidade',
      'GrupoProduto',
      'Horario',
      'Impressoraweb',
      'IntegraAccess',
      'LinhaProduto',
      'LocalEstoque',
      'Logo',
      'Marca',
      'ModalidadeBc',
      'Moeda',
      'NaturezaLesao',
      'NaturezaOperacao',
      'OrigemTributaria',
      'Pais',
      'ParteCorpo',
      'Plano',
      'Planoconta',
      'Planoentidade',
      'ProcedimentoDiagnostico',
      'Produto',
      'RegiaoEntidade',
      'Roteiro',
      'Rubrica',
      'SecaoCnae',
      'SituacaoGeradora',
      'SituacaoTributaria',
      'SituacaoTributariaClassificacao',
      'TabelaPreco',
      'TipoContato',
      'TipoDocumento',
      'TipoEndereco',
      'TipoVinculo',
      'Treinamento',
      'Tributo',
      'UF',
      'UnidadeMedida',
      'Users',
    ]);
  }, []);

  useEffect(() => {
    if (relatorio) {
      openDialog(<RelatorioModal relatorio={relatorio} />, relatorio?.nome);
    }
  }, [relatorio]);

  return (
    <div style={styles.main}>
      <Navbar />
      <Scrollbars>
        <div style={styles.container}>
          <Routes />
        </div>
      </Scrollbars>
    </div>
  );
};

export default App;
